import {createSelector} from 'reselect'
import {TaskSortBy} from '../constants'
import {selectTaskManagement} from '../selectors'
import {
    getIsSummaryRowShown as getIsSummaryRowShownFromTable,
    getSummaryRow,
    getShownColumns,
} from '../tasksTable/selectors'

export const getExportState = (state) => selectTaskManagement(state).exportCsvTaskList
export const getIsSummaryRowShown = createSelector(
    getIsSummaryRowShownFromTable,
    getSummaryRow,
    getShownColumns,
    (isShown, summaryRow, shownColumns) => {
        const summaryColumnsShown = shownColumns.includes(TaskSortBy.ESTIMATE) || shownColumns.includes(TaskSortBy.SPENT_TIME)
        const areSummaryColumnsNotEmpty = [summaryRow.spentTime, summaryRow.estimate].some((column) => column !== undefined)

        return isShown && areSummaryColumnsNotEmpty && summaryColumnsShown
    }
)



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/selectors.js